/** Maps API workspace types (backend-agnostic string surface). */
export enum MapWorkspaceType {
  Gis = 'GIS',
  Survey = 'Survey',
  FileViewer = 'FileViewer',
  Unknown = 'Unknown',
}

export interface MapWorkspace {
  readonly id: string;
  readonly name: string;
  readonly type: MapWorkspaceType;
  readonly layerIds: readonly string[];
}
